"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollFix = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
class ScrollFix {
    constructor(element) {
        this.spacing = 100;
        this.element = null;
        this.eventDate = null;
        this.init = () => {
            var _a;
            const targetId = `calendar-day-${this.eventDate}`;
            const targetTop = (_a = document.getElementById(targetId)) === null || _a === void 0 ? void 0 : _a.offsetTop;
            if (targetId && targetTop) {
                const scrollToDate = targetTop - this.spacing;
                window.scroll({
                    top: scrollToDate,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            (0, cash_dom_1.default)('body').on('scroll', (event) => {
                var _a;
                console.log(window.scroll, (_a = document.getElementById(targetId)) === null || _a === void 0 ? void 0 : _a.scroll());
            });
        };
        if (!element) {
            return;
        }
        this.element = element;
        this.eventDate = this.element.attr('data-eventdate');
        if (!this.eventDate) {
            return;
        }
        setTimeout(this.init, 10);
    }
}
exports.ScrollFix = ScrollFix;
